export default "__VITE_ASSET__rNqol2Fx__"